import { Button } from 'components/atoms/Button';
import { GLOBAL_CONTAINER_ID } from 'components/commons/GlobalPortal';
import { MODAL_CONTAINER_BASE_CLASSNAME } from 'components/commons/modal';
import { DROPDOWN_CONTAINER_BASE_CLASSNAME } from 'components/commons/SelectBox/SelectBoxDropdown';
import { TASK_CARD_LIST_BASE_CLASSNAME } from 'components/commons/TaskCardList';
import { TOOLTIP_CONTAINER_BASE_CLASSNAME } from 'components/commons/Tooltip/GlobalTooltip';

import styledBase, { createGlobalStyle } from 'styled-components';

const styled = Object.assign(styledBase, { createGlobalStyle });

export const GlobalStyle = styled.createGlobalStyle`
  html,
  body,
  #root {
    position: relative;
  }

  html,
  #root {
    height: 100%;
  }

  body {
    background-color: #fff;
    height: 100%;

    @media (min-width: 768px) {
      // 서비스 기준 최소 가로 해상도
      min-width: 1280px;
      overflow-x: auto;
    }
  }

  *,
  *::before,
  *::after {
    box-sizing: unset;
  }

  input,
  button,
  textarea,
  select {
    font: inherit;
  }

  button,
  select {
    text-transform: initial;
  }

  a {
    text-decoration: none;
  }

  #application {
    height: 100%;
  }
  b,
  strong {
    font-weight: bold;
  }
  ${`#${GLOBAL_CONTAINER_ID}`} {
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    z-index: 1000;
  }

  ${`#${GLOBAL_CONTAINER_ID}`} > ${`.${TOOLTIP_CONTAINER_BASE_CLASSNAME}`} {
    z-index: 100;
  }

  ${`#${GLOBAL_CONTAINER_ID}`} > ${`.${DROPDOWN_CONTAINER_BASE_CLASSNAME}`} {
    z-index: 50;
  }

  ${`#${GLOBAL_CONTAINER_ID}`} > ${`.${MODAL_CONTAINER_BASE_CLASSNAME}`} {
    z-index: 2;
  }
  ${`#${GLOBAL_CONTAINER_ID}`} > ${`.${TASK_CARD_LIST_BASE_CLASSNAME}`} {
    z-index: 1;
  }

  ${Button} + ${Button} {
    margin-left: 10px;
  }

  .div-pagination {
    position: relative;
    display: inline-block;
    width: 100%;
    max-width: 100%;
    text-align: center;
  }

  //swal
  .swal2-content #swal2-content,
  .swal2-html-container {
    font-size: 14px !important;
  }

  body.swal2-height-auto {
    height: 100% !important;
  }

  .swal2-modal .swal2-styled {
    margin: 0 !important;
    padding: 5px 33px !important;
    height: 40px;
  }

  .swal2-container {
    z-index: 10001 !important;
  }

  .wrapper-scroll::-webkit-scrollbar-track {
    border-radius: 10px;
  }

  .wrapper-scroll::-webkit-scrollbar {
    width: 7px;
  }

  .wrapper-scroll::-webkit-scrollbar-thumb {
    border-radius: 10px;
  }

  .hand {
    cursor: pointer;
  }

  .pointer {
    cursor: pointer;
  }

  .page-navigation {
    float: right;
  }

  /**
   * swal2 custom style
   */

  .swal2-popup {
    box-sizing: border-box;
    padding: 52px 10px;
    row-gap: 32px;
    min-width: 386px;
    max-width: 392px;
    width: auto;
    border-radius: 10px;
  }

  .swal2-icon {
    margin: 0 auto;
  }

  .swal2-checkbox {
    margin: 0 auto;
  }

  .annotationLayer .popup {
    display: none;
  }

  .swal2-html-container {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto !important;
    padding: 0 16px !important;
    color: ${({ theme }) => theme.mantineColors.gray[7]} !important;
  }

  .swal2-actions {
    margin: 0 auto;
    max-width: 392px;
    gap: 10px;
    font-size: 16px;
  }

  .fire-error-html-container important-note {
    font-weight: bold;
    color: ${({ theme }) => theme.mantineColors.red[6]};
  }

  .fire-error-html-container a {
    text-decoration: underline;
    color: ${({ theme }) => theme.mantineColors.gray[7]};
    font-weight: bold;
  }

  .swal-user-remove .swal2-checkbox .swal2-label {
    font-size: 14px;
    color: ${({ theme }) => theme.mantineColors.gray[8]};
  }
  .swal-user-remove .swal2-popup {
    max-width: 524px;
  }
  .swal-user-remove .swal2-checkbox {
    padding: 0 16px;
    column-gap: 6px;
  }

  .cancel-button {
    box-sizing: border-box;
    display: inline-flex !important;
    justify-content: center;
    align-items: center;
    flex-grow: 1;
    height: 34px;
    padding: 10px 14px;

    font-size: 14px;
    font-weight: 700;

    color: ${({ theme }) => theme.mantineColors.gray[7]} !important;
    border: 1px solid ${({ theme }) => theme.mantineColors.gray[7]} !important;
    background-color: ${({ theme }) => theme.mantineColors.gray[1]} !important;
    border-radius: 3px;

    &:hover {
      box-shadow: 0px 0px 4px 0px rgba(30, 108, 216, 0.4);
      background-image: unset !important;
    }

    &:active {
      background-color: ${({ theme }) => theme.mantineColors.blue[2]} !important;
      background-image: unset !important;
    }
  }

  .confirm-actions {
    display: grid !important;
    grid-template-columns: 1fr 1fr;
    font-size: 16px !important;
    gap: 10px;
  }

  .deny-button {
    display: inline-flex !important;
    flex-grow: 1;
    justify-content: center;
    align-items: center;
    height: 40px;
    padding: 8px 34px;
    box-sizing: border-box;
    line-height: 24px;

    color: ${({ theme }) => theme.mantineColors.gray[1]};
    font-size: 16px;
    font-weight: 700;

    background-color: ${({ theme }) => theme.mantineColors.red[6]};
    border: none;
    border-radius: 5px;
  }

  .confirm-button {
    display: inline-flex !important;
    flex-grow: 1;
    justify-content: center;
    align-items: center;
    height: 40px;
    padding: 8px 34px;
    box-sizing: border-box;
    line-height: 24px;

    color: ${({ theme }) => theme.mantineColors.gray[1]};
    font-weight: 700;

    background-color: ${({ theme }) => theme.mantineColors.blue[6]};
    border: none;
    border-radius: 5px;

    &:hover {
      box-shadow: 0px 0px 4px 0px rgba(30, 108, 216, 0.4);
    }

    &:active {
      background-color: ${({ theme }) => theme.mantineColors.blue[9]};
    }
  }
  .confirm-icon {
    border: unset;
    min-height: 72px;
  }

  .warning-icon {
    border-color: ${({ theme }) => theme.mantineColors.navy[3]} !important;
    color: ${({ theme }) => theme.mantineColors.navy[3]} !important;
  }

  .confirm-html-container {
    color: ${({ theme }) => theme.mantineColors.gray[6]};
  }

  .ellipsis {
    white-space: nowrap;
    overflow-x: hidden;
    text-overflow: ellipsis;
  }

  @keyframes card-blink {
    50% {
      opacity: 0;
    }
  }
`;

export const GlobalPrintPageStyle = styled.createGlobalStyle`
  @page {
    size: A4;
  }

  @media print {
    body {
      transform: scale(0.7);
      transform-origin: top left;
      width: 142.857143%; // to simulate zoom : oldWidth / newScale => 100 / 0.7
    }
    #spendit-global-nav-bar {
      visibility: hidden;
    }
    table {
      page-break-inside: auto;
    }
    thead {
      display: table-header-group;
      break-inside: auto;
    }
    tfoot {
      display: table-footer-group;
    }
  }
`;
